(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["market-resources"] && !Shopify.designMode) return;
  try {
    
  window.marketResourcesSectionComponent = function (pimUrl, locale) {
    return {
      resourcesCategories: [],
      pimUrl: pimUrl,
      locale: locale || 'en',
      // PIM text fields are objects keyed by language code ({ en: '...', de: '...' }).
      // Use the storefront language, fall back to its base language, then English.
      pimText: function (field) {
        if (!field || typeof field !== 'object') return field || '';
        return field[this.locale] || field[this.locale.split('-')[0]] || field.en || '';
      },
      activeCategory: null,
      activeCollection: null,
      init: function () {
        this.loadResources();
      },
      loadResources: async function () {
        const response = await fetch(`${this.pimUrl}/api/resource-categories`);
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        this.resourcesCategories = data.data.filter(item => item.availabilities && item.availabilities.includes('gaia'));
      },
      loadCategory: async function (categoryId) {
        const response = await fetch(`${this.pimUrl}/api/resource-categories/${categoryId}/collections`);
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        this.activeCategory.collections = data.data.filter(item => item.availabilities && item.availabilities.includes('gaia'));

        const collectionsLoadPromises = this.activeCategory.collections.map(async (collection) => {
          if (collection.files) {
            return;
          }
          const response = await fetch(`${this.pimUrl}/api/resource-collections/${collection.id}/resources`);
          if (!response.ok) {
            return;
          }
          const data = await response.json();
          collection.files = data.data.filter(item => item.availabilities && item.availabilities.includes('gaia'));
        });
        await Promise.all(collectionsLoadPromises);
      },
      setActiveCategory: function (category) {
        this.activeCategory = category;
        if (this.activeCategory.collections) {
          return;
        }
        this.loadCategory(category.id);
      },
      downloadFiles: function (event, files) {
        if (files.length === 0) {
          return;
        }
        event.preventDefault();
        files.forEach((fileUrl, index) => {
          setTimeout(() => {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = 'file';
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }, index * 500); // delay to avoid browser blocking
        });
      },
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-documents"] && !Shopify.designMode) return;
  try {
    
  window.ourDocumentsComponent = function (pimUrl) {
    return {
      documents: [],
      init: async function () {
        const response = await fetch(`${pimUrl}/api/our-documents/gaia`);
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        this.documents = data.data.filter(doc => doc.is_available_for_gaia);
      },
    };
  };

  } catch(e) { console.error(e); }
})();
})();
